// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3qbEY","header":"ReportDetails_header__-ubDR","title":"ReportDetails_title__3Qn3k","left":"ReportDetails_left__1QWD1"};